/*
 * avis-clients.js
 * Comportement de sections/avis-clients.liquid.
 *
 * - Les fleches font defiler la rangee d'une page ; elles se desactivent aux
 *   deux extremites.
 * - Dans l'editeur de theme, selectionner un bloc « Avis » fait defiler la
 *   rangee jusqu'a sa carte.
 *
 * Delegation sur le document : les sections de l'editeur sont rechargees a
 * chaque modification, aucun ecouteur pose sur leur contenu ne survivrait.
 */
(() => {
  const SELECTEUR = 'avis-clients';

  function majFleches(racine) {
    const piste = racine.querySelector('[data-ac-piste]');
    const prec = racine.querySelector('[data-ac-precedent]');
    const suiv = racine.querySelector('[data-ac-suivant]');
    if (!piste || !prec || !suiv) return;
    prec.disabled = piste.scrollLeft < 2;
    suiv.disabled = piste.scrollWidth - piste.clientWidth - piste.scrollLeft < 2;
  }

  document.addEventListener('click', (evt) => {
    const bouton = evt.target instanceof Element ? evt.target.closest('[data-ac-precedent], [data-ac-suivant]') : null;
    if (!bouton) return;
    const racine = bouton.closest(SELECTEUR);
    const piste = racine && racine.querySelector('[data-ac-piste]');
    if (!piste) return;

    const sens = bouton.hasAttribute('data-ac-precedent') ? -1 : 1;
    const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    piste.scrollBy({ left: sens * piste.clientWidth * 0.85, behavior: reduit ? 'auto' : 'smooth' });
  });

  // Le defilement ne remonte pas : on l'ecoute en phase de capture.
  document.addEventListener('scroll', (evt) => {
    const cible = evt.target instanceof Element ? evt.target : null;
    if (!cible || !cible.hasAttribute('data-ac-piste')) return;
    const racine = cible.closest(SELECTEUR);
    if (racine) majFleches(racine);
  }, true);

  function initialiser(portee) {
    (portee || document).querySelectorAll(SELECTEUR).forEach(majFleches);
  }

  window.addEventListener('resize', () => initialiser());
  window.addEventListener('load', () => initialiser());
  if (document.readyState !== 'loading') initialiser();
  else document.addEventListener('DOMContentLoaded', () => initialiser());

  // Editeur de theme.
  document.addEventListener('shopify:section:load', (evt) => initialiser(evt.target));
  document.addEventListener('shopify:block:select', (evt) => {
    const carte = evt.target instanceof Element ? evt.target.closest('.ac__carte') : null;
    const piste = carte && carte.closest('[data-ac-piste]');
    if (!piste) return;
    piste.scrollTo({ left: carte.offsetLeft - piste.offsetLeft, behavior: 'auto' });
  });
})();
